import { CONTACT_SUPPORT_URL } from '@utils/constants/mock-exam.constants';
import React from 'react';

const ThankYouPage = ({ parentEmail }: { parentEmail: string }) => {
  return (
    <>
      <p className="text-neutral-pencil mb-8 break-words">
        A summary of the mock exams you registered for along with an exclusive
        webinar offer has been sent to {parentEmail}
        <br />
        <br />
        Please note: the email may take a few minutes to arrive. Please check
        your spam mailboxes.
      </p>
      <p className="text-neutral-pencil">
        Need help?{' '}
        <a
          href={CONTACT_SUPPORT_URL}
          target="_blank"
          className="text-primary-apricot underline font-medium"
          rel="noreferrer"
        >
          Contact our support team
        </a>
      </p>
    </>
  );
};

export default ThankYouPage;
